import { MIXER_10, MIXER_6 } from "./dimensions";
import { Mixer10Body, Mixer6Body } from "./MixerBody";
import { MIXER_10_LAYOUT, MIXER_10_WHEELS, MIXER_6_LAYOUT, MIXER_6_WHEELS } from "./wheels";
const mixer10Preset = {
  id: "mixer-10-transit",
  silhouette: "mixer",
  renderModelKey: "mixer",
  renderLayoutKey: "mixer-10-wheel-v1",
  label: "3 axles, single steer and tandem dual drive",
  layout: MIXER_10_LAYOUT,
  wheels: MIXER_10_WHEELS,
  camera: {
    position: [10.2, 4.8, 9.2],
    target: [0, 1.7, 0],
    minDistance: 7,
    maxDistance: 26,
    fov: 32
  },
  stage: { extent: MIXER_10.length, contactHeight: 1.4 },
  skeleton: "axles",
  Body: Mixer10Body
};
const mixer6Preset = {
  id: "mixer-6-transit",
  silhouette: "mixer",
  renderModelKey: "mixer",
  renderLayoutKey: "mixer-6-wheel-v1",
  label: "2 axles, single steer and dual drive",
  layout: MIXER_6_LAYOUT,
  wheels: MIXER_6_WHEELS,
  camera: {
    position: [8.8, 4.3, 8],
    target: [0, 1.55, 0],
    minDistance: 6,
    maxDistance: 22,
    fov: 32
  },
  stage: { extent: MIXER_6.length, contactHeight: 1.3 },
  skeleton: "axles",
  Body: Mixer6Body
};
export {
  mixer10Preset,
  mixer6Preset
};
